import Endpoint from '../Endpoint'

export default class Signup extends Endpoint {
  async create(params) {
    return this.client.request({
      method: 'POST',
      endpoint: '/signup',
      data: params,
    })
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/Signup.js